import { Provider } from 'react-redux';
import store, { persistor } from 'redux/Store';
import Layout from 'pages/Layout';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import "react-datepicker/dist/react-datepicker.css";
import 'assets/css/Animations.css';
import 'assets/css/Fonts.css';
import 'assets/css/Responsive.css';
import "react-bootstrap-submenu/dist/index.css"
import 'components/translate/i18n';
import "../src/assets/css/DarkThemeOverride.css"

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer theme="dark" />
        <Layout />
      </PersistGate>
    </Provider>
  );
}

export default App;
